import React from 'react';

export const PlayIcon = () =>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 512.13 512.13" xmlSpace="preserve" fill="white">

    <path d="M346.541,221.958l-121.198-87.091c-11.977-8.591-27.338-11.977-39.315-5.077c-11.977,5.077-18.746,18.747-18.746,34.107
			v184.335c0,15.361,6.769,27.338,18.746,34.107c5.077,1.692,10.284,3.385,15.361,3.385c8.592,0,17.054-3.385,23.953-10.285
			l121.198-87.092c11.977-8.591,18.746-20.439,18.746-34.107C365.286,242.397,358.518,230.42,346.541,221.958z M326.102,262.835
			l-121.198,87.091c-1.692,0-3.385,1.692-3.385,1.692s0-1.692,0-3.385V163.899c0-1.692,0-3.385,0-3.385
			c1.692,0,1.692,1.692,5.077,3.385l121.197,87.091c1.692,0,3.385,3.385,3.385,5.077S329.487,261.141,326.102,262.835z"/>

    <path d="M256.065,0C114.43,0,0,114.298,0,256.065S114.298,512.13,256.065,512.13S512.13,397.832,512.13,256.065
			S397.702,0,256.065,0z M256.065,477.892c-122.891,0-221.828-98.937-221.828-221.828S133.175,34.236,256.065,34.236
			s221.828,98.937,221.828,221.828S378.956,477.892,256.065,477.892z"/>

  </svg>;

export const PauseIcon = () =>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 512.13 512.13" xmlSpace="preserve" fill="white">

    <path d="M256.065,0C114.43,0,0,114.298,0,256.065S114.298,512.13,256.065,512.13S512.13,397.832,512.13,256.065
			S397.702,0,256.065,0z M256.065,477.892c-122.891,0-221.828-98.937-221.828-221.828S133.175,34.236,256.065,34.236
			s221.828,98.937,221.828,221.828S378.956,477.892,256.065,477.892z"/>

    <path d="M216.88,143.459c-10.284,0-17.054,6.769-17.054,17.053v191.105c0,10.285,6.769,17.053,17.054,17.053
        c8.592,0,17.054-6.769,17.054-17.053V160.513C233.935,150.229,227.035,143.459,216.88,143.459z"/>

    <path d="M295.38,143.459c-10.284,0-17.054,6.769-17.054,17.053v191.105c0,10.285,6.769,17.053,17.054,17.053
        s17.054-6.769,17.054-17.053V160.513C312.433,150.229,305.534,143.459,295.38,143.459z"/>

  </svg>;

export const PlayCircleIcon = () =>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 271.953 271.953" xmlSpace="preserve" fill="white">
    <path d="M135.977,271.953c75.097,0,135.977-60.879,135.977-135.977S211.074,0,135.977,0S0,60.879,0,135.977
			S60.879,271.953,135.977,271.953z M250.197,135.977c0,62.979-51.241,114.22-114.22,114.22s-114.22-51.241-114.22-114.22
			s51.241-114.22,114.22-114.22S250.197,72.998,250.197,135.977z"/>
    <path d="M112.295,205.031c2.692,1.115,5.434,1.659,8.235,1.659c5.662,0,11.183-2.208,15.344-6.375
			l48.93-48.952c8.496-8.496,8.485-22.273-0.011-30.769l-48.957-48.952c-4.161-4.161-9.73-6.375-15.393-6.375
			c-2.801,0-5.461,0.544-8.153,1.659c-8.126,3.367-13.255,11.297-13.255,20.097v97.903
			C99.034,193.729,104.164,201.664,112.295,205.031z M120.791,88.613v-1.588l48.952,48.952l-48.952,48.952V88.613z"/>
  </svg>;

export const PauseCircleIcon = () =>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 271.953 271.953" xmlSpace="preserve" fill="white">
    <path d="M135.977,271.953c75.097,0,135.977-60.879,135.977-135.977S211.074,0,135.977,0S0,60.879,0,135.977
			S60.879,271.953,135.977,271.953z M135.977,21.756c62.979,0,114.22,51.241,114.22,114.22s-51.241,114.22-114.22,114.22
			s-114.22-51.241-114.22-114.22S72.992,21.756,135.977,21.756z"/>
    <path d="M110.707,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598
			c-7.511,0-13.598,6.086-13.598,13.598v103.342C97.109,194.028,103.195,200.114,110.707,200.114z"/>
    <path d="M165.097,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598
			S151.5,75.663,151.5,83.174v103.342C151.5,194.028,157.586,200.114,165.097,200.114z"/>
  </svg>;
